var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FieldRichText, FieldText, ModalBody, ModalFoot, ModalHead, } from '@dixa/lib-shared-habla';
import { boundMethod } from 'autobind-decorator';
import { Component } from 'react';
import { v4 as uuid } from 'uuid';
import { SanitizeHTML } from 'app/utils/htmlSanitizer';
import { FlowNodeTypes } from 'components/powerFlowShared/components/types';
import { getConfirmButtonVerb } from 'components/powerFlowShared/helpers/getConfirmButtonVerb';
import { WidgetPreview } from '../../../conversation/components/widgetPreview';
export default class ChatInputModal extends Component {
    constructor(props) {
        super(props);
        let payload;
        if (this.props.node.payload !== null) {
            payload = this.props.node.payload;
        }
        else {
            payload = {
                field_label: '',
                field_placeholder: '',
                message: '',
                nextNodeId: uuid(),
            };
        }
        this.state = {
            errors: {},
            hasChanges: false,
            isDirty: false,
            payload,
        };
    }
    prepareNode() {
        return Object.assign(Object.assign({}, this.props.node), { badges: [], icon: '', isAction: false, isEditable: true, isRemovable: true, nodeType: FlowNodeTypes.CHAT_INPUT, overlay: [], payload: this.state.payload, text: 'Input' });
    }
    updatePayload(updateObj) {
        this.setState({
            hasChanges: true,
            payload: Object.assign(Object.assign({}, this.state.payload), updateObj),
        }, () => {
            if (this.state.isDirty) {
                this.validate();
            }
        });
    }
    handleMessageChange(message) {
        this.updatePayload({ message });
    }
    handleLabelChange(event) {
        this.updatePayload({ field_label: event === null || event === void 0 ? void 0 : event.target.value });
    }
    handlePlaceholderChange(event) {
        this.updatePayload({ field_placeholder: event === null || event === void 0 ? void 0 : event.target.value });
    }
    handleCancel() {
        this.props.triggerClose();
    }
    handleSave() {
        const { replaceNode, triggerClose } = this.props;
        if (this.validate()) {
            replaceNode(this.prepareNode());
            triggerClose();
            this.setState({
                hasChanges: false,
            });
        }
        else {
            this.setState({
                isDirty: true,
            });
        }
    }
    validate() {
        const { payload: { message, field_label }, } = this.state;
        const errors = {};
        if (message.trim() === '') {
            errors.message = 'Please fill out a message';
        }
        if (field_label.trim() === '') {
            errors.field_label = 'Please fill out a label';
        }
        this.setState({
            errors,
        });
        return Object.keys(errors).length === 0;
    }
    render() {
        const { errors, payload: { message, field_label, field_placeholder }, } = this.state;
        const { node, nodeLabel } = this.props;
        return (_jsxs("div", Object.assign({ className: "conversational-modal modal-chatflow-holder" }, { children: [_jsx(ModalHead, Object.assign({ title: nodeLabel, onClose: this.handleCancel }, { children: "The \"Input\" action allows you to ask customers for specific information (e.g. customer number or order number)." })), _jsx(ModalBody, { children: _jsxs("div", Object.assign({ className: "conversational-modal__columns" }, { children: [_jsx("div", Object.assign({ className: "conversational-modal__column" }, { children: _jsx(WidgetPreview, { input: {
                                        label: field_label,
                                        placeholder: field_placeholder,
                                    }, message: message, className: "conversational-modal__preview" }) })), _jsxs("div", Object.assign({ className: "conversational-modal__column" }, { children: [_jsx(FieldRichText, { required: true, allowFormatting: true, sanitize: SanitizeHTML.sanitizerForProfile('widgetchat'), className: "conversational-modal__input", label: "Your message", meta: { error: errors.message }, input: {
                                            name: 'message',
                                            onChange: this.handleMessageChange,
                                            value: message,
                                        } }), _jsx(FieldText, { required: true, className: "conversational-modal__input", label: "Field label", placeholder: "E.g. customer number", meta: { error: errors.field_label }, input: {
                                            name: 'label',
                                            onChange: this.handleLabelChange,
                                            value: field_label,
                                        } }), _jsx(FieldText, { className: "conversational-modal__input", label: "Field placeholder", placeholder: "E.g. XXXX-XXXX-XXXX", meta: {}, input: {
                                            name: 'placeholder',
                                            onChange: this.handlePlaceholderChange,
                                            value: field_placeholder,
                                        } })] }))] })) }), _jsx(ModalFoot, { confirmOnClick: this.handleSave, confirmName: getConfirmButtonVerb(node), cancelOnClick: this.handleCancel })] })));
    }
}
__decorate([
    boundMethod
], ChatInputModal.prototype, "prepareNode", null);
__decorate([
    boundMethod
], ChatInputModal.prototype, "handleMessageChange", null);
__decorate([
    boundMethod
], ChatInputModal.prototype, "handleLabelChange", null);
__decorate([
    boundMethod
], ChatInputModal.prototype, "handlePlaceholderChange", null);
__decorate([
    boundMethod
], ChatInputModal.prototype, "handleCancel", null);
__decorate([
    boundMethod
], ChatInputModal.prototype, "handleSave", null);
